import { useFormContext } from "react-hook-form";

import { Accordion } from "ui/accordion";
import { Box } from "ui/box";
import { FormSelect } from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/components/form-select";
import { PaddingField } from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/components/padding-field";

import type {
  ContentBlockName,
  EmailConfigurationFormValues,
} from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration.types";

import { FIELDS_SX } from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration.styles";
import {
  CONTENT_BLOCK_GROUPS,
  CONTENT_BLOCKS,
} from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration.constants";

type LayoutSectionProps = { disabled: boolean };

const ResponsivePaddingFields = ({
  block,
  disabled,
}: LayoutSectionProps & { block: ContentBlockName | "allBlocks" }) => (
  <Box sx={FIELDS_SX}>
    <PaddingField name={`layout.contentBlock.${block}.mobile`} label="Mobile padding (px)" disabled={disabled} />
    <PaddingField name={`layout.contentBlock.${block}.desktop`} label="Desktop padding (px)" disabled={disabled} />
  </Box>
);

export const LayoutSection = ({ disabled }: LayoutSectionProps) => {
  const { watch } = useFormContext<EmailConfigurationFormValues>();
  const isCustomGroup = watch("layout.contentBlock.group") === "custom";

  return (
    <>
      <Accordion title="Content area" defaultExpanded>
        <PaddingField name="layout.contentArea" label="Padding (px)" disabled={disabled} />
      </Accordion>
      <Accordion title="Content blocks" defaultExpanded>
        <Box sx={FIELDS_SX}>
          <FormSelect
            name="layout.contentBlock.group"
            label="Apply to"
            options={CONTENT_BLOCK_GROUPS}
            disabled={disabled}
          />
          {isCustomGroup ? (
            CONTENT_BLOCKS.map(({ name, title }) => (
              <Accordion key={name} title={title} variant="secondary">
                <ResponsivePaddingFields block={name} disabled={disabled} />
              </Accordion>
            ))
          ) : (
            <ResponsivePaddingFields block="allBlocks" disabled={disabled} />
          )}
        </Box>
      </Accordion>
    </>
  );
};
